import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import ConfirmDialog from './ConfirmDialog';
import { useAuth } from '../../contexts/AuthContext';
import adminService from '../../services/adminService';

const AdminArticleMenu = ({ articleId, onDeleteSuccess, className = '', compact = false }) => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  if (!isAdmin) return null;

  const handleEdit = () => {
    setIsOpen(false);
    navigate(`/creator-studio/${articleId}`);
  };

  const handleDeleteClick = () => {
    setIsOpen(false);
    setShowConfirm(true);
  };

  const handleConfirmDelete = async () => {
    setDeleting(true);
    try {
      await adminService.deleteArticle(articleId);
      setShowConfirm(false);
      onDeleteSuccess?.();
    } catch (err) {
      console.error('Failed to delete article:', err);
      setDeleting(false);
    }
  };

  return (
    <div ref={menuRef} className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${compact ? 'p-1.5' : 'w-14 h-14'} rounded-full flex items-center justify-center transition-all duration-300`}
        style={{
          backgroundColor: isOpen
            ? 'rgba(197, 160, 89, 0.2)'
            : compact ? 'transparent' : 'rgba(197, 160, 89, 0.1)',
        }}
        aria-label="خيارات المشرف"
      >
        <Icon name="MoreVertical" size={compact ? 20 : 22} color="#C5A059" />
      </button>

      {isOpen && (
        <div
          className={`absolute ${compact ? 'top-10' : 'top-16'} left-0 w-44 rounded-2xl overflow-hidden shadow-lg z-50`}
          style={{
            backgroundColor: '#F9F7F2',
            border: '1px solid rgba(197, 160, 89, 0.15)',
          }}
        >
          <button
            onClick={handleEdit}
            className="w-full flex items-center gap-3 px-5 py-3.5 text-sm transition-colors duration-200 hover:bg-[rgba(197,160,89,0.08)]"
            style={{ fontFamily: 'Amiri, serif', color: '#2C2B29' }}
          >
            <Icon name="Pencil" size={16} color="#C5A059" />
            <span>تعديل</span>
          </button>
          <div style={{ borderTop: '1px solid rgba(197, 160, 89, 0.1)' }} />
          <button
            onClick={handleDeleteClick}
            className="w-full flex items-center gap-3 px-5 py-3.5 text-sm transition-colors duration-200 hover:bg-[rgba(220,38,38,0.05)]"
            style={{ fontFamily: 'Amiri, serif', color: '#DC2626' }}
          >
            <Icon name="Trash2" size={16} color="#DC2626" />
            <span>حذف</span>
          </button>
        </div>
      )}

      <ConfirmDialog
        isOpen={showConfirm}
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowConfirm(false)}
        title="حذف المحتوى"
        message="هل أنت متأكد من حذف هذا المحتوى؟ سيتم حذفه نهائيًا ولا يمكن التراجع."
        loading={deleting}
      />
    </div>
  );
};

export default AdminArticleMenu;
